module.exports = __webpack_public_path__ + "img/page_info_pw2.1614be7.svg";